// Custom Wall Art Size Chart Modal
// Handles size chart image modal functionality for the custom-wallart section

function getCwaSizeChartContent() {
  // Get size chart settings from window variables set by Liquid
  const imageUrl = window.cwaSizeChartImage || '';
  const imageWidth = window.cwaSizeChartImageWidth || 600;
  const header = window.cwaSizeChartHeader || '';
  const description = window.cwaSizeChartDescription || '';
  
  if (!imageUrl) {
    return '<p>No size chart image available</p>';
  }
  
  let contentHTML = '';
  
  // Add header if provided
  if (header && header.trim() !== '') {
    contentHTML += `
      <div class="cwa-size-chart-modal__header">
        <h2>${header}</h2>
      </div>
    `;
  }
  
  // Add description if provided
  if (description && description.trim() !== '') {
    contentHTML += `
      <div class="cwa-size-chart-modal__description">
        <p>${description}</p>
      </div>
    `;
  }
  
  // Add image
  contentHTML += `
    <div class="cwa-size-chart-modal__image-container" style="max-width: ${imageWidth}px; width: 100%; margin: 0 auto;">
      <img src="${imageUrl}" alt="Size Chart" class="cwa-size-chart-modal__image" style="width: 100%; height: auto; display: block;">
    </div>
  `;
  
  return contentHTML;
}

function setupCwaSizeChartModal() {
  console.log('📏 [CWA] Setting up custom wall art size chart modal...');
  
  const trigger = document.querySelector('[data-cwa-size-chart-modal-trigger]');
  const modal = document.getElementById('cwa-size-chart-modal');
  
  console.log('📏 [CWA] Trigger found:', !!trigger);
  console.log('📏 [CWA] Modal found:', !!modal);
  
  if (!trigger || !modal) {
    console.log('📏 [CWA] Modal setup failed - missing trigger or modal element');
    return;
  }
  
  // Prevent modal from opening on page load if URL has hash (coming from external links)
  // This prevents accidental triggers when users arrive from Instagram or other sources
  const urlHash = window.location.hash;
  if (urlHash && urlHash !== '') {
    console.log('📏 [CWA] URL has hash, preventing accidental modal trigger:', urlHash);
    // Clear the hash to prevent navigation issues
    if (history.replaceState) {
      history.replaceState(null, null, ' ');
    }
  }
  
  // Insert size chart content into modal
  const contentContainer = modal.querySelector('.cwa-size-chart-modal__content-container');
  if (contentContainer) {
    contentContainer.innerHTML = getCwaSizeChartContent();
  }
  
  const closeButtons = modal.querySelectorAll('[data-cwa-size-chart-modal-close]');
  
  // Function to open modal (extracted for reuse)
  function openModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    console.log('📏 [CWA] Size chart modal trigger clicked!');
    console.log('📏 [CWA] Setting modal display to flex');
    modal.style.display = 'flex';
    console.log('📏 [CWA] Modal display after setting:', modal.style.display);
    
    // Lock body scroll
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '0';
  }
  
  // Track touch events to distinguish taps from scrolls
  let touchStartTime = 0;
  let touchStartY = 0;
  let isScrolling = false;
  
  // Track touchstart for mobile
  trigger.addEventListener('touchstart', function(e) {
    touchStartTime = Date.now();
    touchStartY = e.touches[0].clientY;
    isScrolling = false;
  }, { passive: true });
  
  // Track touchmove to detect scrolling
  trigger.addEventListener('touchmove', function(e) {
    const touchY = e.touches[0].clientY;
    const touchDistance = Math.abs(touchY - touchStartY);
    if (touchDistance > 5) {
      isScrolling = true;
    }
  }, { passive: true });
  
  // Handle touchend - only open if it's a deliberate tap, not a scroll
  trigger.addEventListener('touchend', function(e) {
    const touchDuration = Date.now() - touchStartTime;
    const touchEndY = e.changedTouches[0].clientY;
    const touchDistance = Math.abs(touchEndY - touchStartY);
    
    // Only open modal if it's a quick tap (not a scroll) and intentional
    if (!isScrolling && touchDuration < 300 && touchDistance < 10) {
      e.preventDefault();
      e.stopPropagation();
      openModal(e);
    }
    // Reset scroll flag
    isScrolling = false;
  }, { passive: false });
  
  // Open modal on click (for desktop and non-touch devices)
  trigger.addEventListener('click', function(e) {
    // Only handle click if it wasn't already handled by touchend
    // Check if this is a touch device by checking if touchend was recent
    const timeSinceTouch = Date.now() - touchStartTime;
    if (timeSinceTouch > 100) {
      // Not a touch event, handle as regular click
      openModal(e);
    }
  }, { passive: false });
  
  // Handle keyboard accessibility (Enter and Space keys)
  trigger.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      openModal(e);
    }
  });
  
  // Close modal
  closeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeCwaSizeChartModal();
    });
  });
  
  // Close on overlay click
  modal.addEventListener('click', function(e) {
    if (e.target === modal || e.target.classList.contains('cwa-size-chart-modal__overlay')) {
      closeCwaSizeChartModal();
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeCwaSizeChartModal();
    }
  });
  
  function closeCwaSizeChartModal() {
    modal.style.display = 'none';
    
    // Restore body scroll
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
  }
}

// Make function globally available
window.setupCwaSizeChartModal = setupCwaSizeChartModal;

